export type FileSource = 'file' | 'cameraRoll' | 'camera';
export type FileSourceInput = FileSource[] | 'all' | 'photo';
